"use client";

import dynamic from "next/dynamic";

const TransmissionTowerScene = dynamic(
  () =>
    import("./transmission-tower-scene").then(
      (m) => m.TransmissionTowerScene,
    ),
  { ssr: false },
);

export function TransmissionTowerMount() {
  return <TransmissionTowerScene />;
}
